import * as React from 'react';
import DownloadSVG from './DownloadSVG';
import './withDownload.scss';
/**
 * Download Wrapper
 * @param WrappedComponent Wrapped Component
 *
 */
export const withDownload = (WrappedComponent: any) => (props: any) => {
  const [isShown, setIsShown] = React.useState(false);
  const inputRef = React.useRef<any>(null);

  const handleMouseEnter = () => {
    setIsShown(true);
  };

  const downloadImage = () => {
    const canvasElement = inputRef.current.querySelector(
      'canvas.chartjs-render-monitor'
    );

    if (canvasElement) {
      const MIME_TYPE = 'image/png';
      const imgURL = canvasElement.toDataURL(MIME_TYPE);
      const dlLink = document.createElement('a');
      dlLink.download = 'intermix-card.png';
      dlLink.href = imgURL;
      dlLink.dataset.downloadurl = [
        MIME_TYPE,
        dlLink.download,
        dlLink.href,
      ].join(':');

      document.body.appendChild(dlLink);
      dlLink.click();
      document.body.removeChild(dlLink);
    }
  };
  return (
    <div
      ref={inputRef}
      className="download-container"
      id="intermix-card"
      onMouseEnter={() => handleMouseEnter()}
      onMouseLeave={() => setIsShown(false)}
    >
      <WrappedComponent {...props} />
      {isShown && (
        <div className="download" onClick={() => downloadImage()}>
          <DownloadSVG />
        </div>
      )}
    </div>
  );
};
